/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Import_Auto_Offset_TitleInputs */

const en_subtitle_import_auto_offset_title = /** @type {(inputs: Subtitle_Import_Auto_Offset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic Offset`)
};

const fr_subtitle_import_auto_offset_title = /** @type {(inputs: Subtitle_Import_Auto_Offset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decalage automatique`)
};

const de_subtitle_import_auto_offset_title = /** @type {(inputs: Subtitle_Import_Auto_Offset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatischer Offset`)
};

const it_subtitle_import_auto_offset_title = /** @type {(inputs: Subtitle_Import_Auto_Offset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offset automatico`)
};

const ru_subtitle_import_auto_offset_title = /** @type {(inputs: Subtitle_Import_Auto_Offset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическое смещение`)
};

const es_subtitle_import_auto_offset_title = /** @type {(inputs: Subtitle_Import_Auto_Offset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desplazamiento automático`)
};

const zh_cn2_subtitle_import_auto_offset_title = /** @type {(inputs: Subtitle_Import_Auto_Offset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动偏移`)
};

const ja_subtitle_import_auto_offset_title = /** @type {(inputs: Subtitle_Import_Auto_Offset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動オフセット`)
};

const hi_subtitle_import_auto_offset_title = /** @type {(inputs: Subtitle_Import_Auto_Offset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वचालित ऑफसेट`)
};

const pt_pt2_subtitle_import_auto_offset_title = /** @type {(inputs: Subtitle_Import_Auto_Offset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deslocamento automático`)
};

/**
* | output |
* | --- |
* | "Automatic Offset" |
*
* @param {Subtitle_Import_Auto_Offset_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_import_auto_offset_title = /** @type {((inputs?: Subtitle_Import_Auto_Offset_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Import_Auto_Offset_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_import_auto_offset_title(inputs)
	if (locale === "de") return de_subtitle_import_auto_offset_title(inputs)
	if (locale === "it") return it_subtitle_import_auto_offset_title(inputs)
	if (locale === "ru") return ru_subtitle_import_auto_offset_title(inputs)
	if (locale === "es") return es_subtitle_import_auto_offset_title(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_import_auto_offset_title(inputs)
	if (locale === "ja") return ja_subtitle_import_auto_offset_title(inputs)
	if (locale === "hi") return hi_subtitle_import_auto_offset_title(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_import_auto_offset_title(inputs)
	return en_subtitle_import_auto_offset_title(inputs)
});